import React from 'react';
import { Link } from 'react-router-dom';
import {
  APP_STORE_URL, GOOGLE_PLAY_URL,
  WINDOWS_DOWNLOAD_URL, MACOS_DOWNLOAD_URL,
  DOCS_WEB_APP_URL, WHATSAPP_URL, WHATSAPP_NUMBER_DISPLAY,
} from './constants';

export default function SiteFooter({ onOpenChat }) {
  return (
    <footer className="bg-ink-950 text-white border-t border-white/5">
      <div className="max-w-6xl mx-auto px-6 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-7 h-7 rounded-lg bg-brand-600 flex items-center justify-center">
                <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" className="text-white">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <span className="font-bold text-[15px]">Facturas Simples</span>
            </div>
            <p className="text-[13px] text-ink-500 leading-relaxed">
              Facturación electrónica DTE para El Salvador.
            </p>
          </div>

          {/* Producto */}
          <div>
            <h4 className="font-semibold text-[11px] uppercase tracking-wider text-ink-400 mb-4">Producto</h4>
            <ul className="space-y-2.5 text-[14px] text-ink-500">
              <li><a href="#caracteristicas" className="hover:text-white transition">Características</a></li>
              <li><a href="#precios" className="hover:text-white transition">Precios</a></li>
              <li><Link to="/documentacion" className="hover:text-white transition">Documentación</Link></li>
              <li><a href={DOCS_WEB_APP_URL} target="_blank" rel="noopener noreferrer" className="hover:text-white transition">Manual de usuario</a></li>
              <li><Link to="/faq" className="hover:text-white transition">FAQ</Link></li>
            </ul>
          </div>

          {/* Descargas */}
          <div>
            <h4 className="font-semibold text-[11px] uppercase tracking-wider text-ink-400 mb-4">Descargas</h4>
            <ul className="space-y-2.5 text-[14px] text-ink-500">
              <li><a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" className="hover:text-white transition">App Store (iOS)</a></li>
              <li><a href={GOOGLE_PLAY_URL} target="_blank" rel="noopener noreferrer" className="hover:text-white transition">Google Play (Android)</a></li>
              <li><a href={WINDOWS_DOWNLOAD_URL} target="_blank" rel="noopener noreferrer" className="hover:text-white transition">Windows</a></li>
              <li><a href={MACOS_DOWNLOAD_URL} target="_blank" rel="noopener noreferrer" className="hover:text-white transition">macOS</a></li>
            </ul>
          </div>

          {/* Soporte */}
          <div>
            <h4 className="font-semibold text-[11px] uppercase tracking-wider text-ink-400 mb-4">Soporte</h4>
            <ul className="space-y-2.5 text-[14px] text-ink-500">
              <li><a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="hover:text-white transition">WhatsApp {WHATSAPP_NUMBER_DISPLAY}</a></li>
              <li><Link to="/cotizacion" className="hover:text-white transition">Solicitar cotización</Link></li>
              <li>
                <button onClick={onOpenChat} className="hover:text-white transition cursor-pointer text-left">
                  Soporte 24/7
                </button>
              </li>
              <li><a href="/privacy.html" className="hover:text-white transition">Privacidad</a></li>
              <li><a href="/terms.html" className="hover:text-white transition">Términos</a></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-[13px] text-ink-500">© 2026 K Labs S.A. de C.V. — Todos los derechos reservados.</p>
          <a href="https://www.facebook.com/share/1UKMZgKeuH/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="text-ink-600 hover:text-white transition">
            <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
              <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd"/>
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
}
